import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function ErrorState({
  title = 'Something went wrong',
  description = "We couldn't load this view. Try again.",
  onRetry,
}: {
  title?: string;
  description?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="h-16 w-16 rounded-full bg-status-error-bg text-status-error flex items-center justify-center mb-4">
        <AlertCircle className="h-7 w-7" />
      </div>
      <h3 className="text-h3 text-ink">{title}</h3>
      <p className="mt-2 max-w-md text-body text-ink-muted">{description}</p>
      {onRetry && (
        <Button onClick={onRetry} variant="secondary" className="mt-5">
          Try again
        </Button>
      )}
    </div>
  );
}
